import _ from 'underscore';
import angular from 'angular';

export default class ProductEndUsesManage {
  constructor($scope, $rootScope, ProductService) {
    $scope.product = window.product;
    $scope.product_categories = window.product_categories;
    $scope.product_end_uses = window.product_end_uses;

    $scope.quick_search = this.quick_search.bind(this);
    $scope.update = this.update.bind(this);
    $scope.open_add_dialog = this.open_add_dialog.bind(this);

    $scope.product_category_id = $scope.product.product_category_id;
    $scope.product_group_id = $scope.product.product_group_id;

    $scope.$watch('product_category_id', this.load_groups.bind(this));
    $scope.$watch('product_group_id', this.load_products.bind(this));
    $scope.$watch('product_id', this.load_suggested_product_end_uses.bind(this));

    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.ProductService = ProductService;

    this.load_product_end_uses();
  }

  load_groups() {
    if (!this.$scope.product_category_id) {
      return;
    }

    this.ProductService.get_groups(this.$scope.product_category_id)
      .then((data) => {
        this.$scope.product_groups = data.groups;
      });
  }

  load_products() {
    if (!this.$scope.product_group_id) {
      return;
    }

    this.ProductService.get_products(this.$scope.product_group_id)
      .then((data) => {
        this.$scope.products = data.products;

        this.load_suggested_group_end_uses();
      });
  }

  load_product_end_uses() {
    if (!this.$scope.product.id) {
      return;
    }

    this.ProductService.get_product_end_uses(this.$scope.product.id)
      .then((data) => {
        _.each(data.end_uses, (end_use) => {
          var product_end_use = _.findWhere(this.$scope.product_end_uses, {
            id: end_use.id
          });
          if (product_end_use) {
            product_end_use.checked = true;
          }
        });
      });
  }

  load_suggested_group_end_uses() {
    if (!this.$scope.product_group_id) {
      return;
    }

    this.ProductService
      .get_product_group_end_uses(this.$scope.product_group_id)
      .then((response) => {
        this.clear_suggested_end_uses();

        _.each(response.data.end_uses, (end_use) => {
          var product_end_use = _.findWhere(this.$scope.product_end_uses, {
            id: end_use
          });
          if (product_end_use) {
            product_end_use.suggested = true;
          }
        });
      });
  }

  load_suggested_product_end_uses(nextProductId, prevProductId) {
    if (!nextProductId) {
      if (prevProductId) {
        this.load_suggested_group_end_uses();
      }

      return;
    }

    this.ProductService.get_product_end_uses(nextProductId)
      .then((data) => {
        this.clear_suggested_end_uses();

        _.each(data.end_uses, (end_use) => {
          var product_end_use = _.findWhere(this.$scope.product_end_uses, {
            id: end_use.id
          });
          if (product_end_use) {
            product_end_use.suggested = true;
          }
        });
      });
  }

  clear_suggested_end_uses() {
    _.each(this.$scope.product_end_uses, (end_use) => {
      if (end_use.suggested) {
        end_use.suggested = false;
      }
    });
  }

  quick_search() {
    if (this.$scope.quick_filter) {
      var regex = new RegExp(this.$scope.quick_filter, 'i');
      _.each(this.$scope.product_end_uses, function(end_use) {
        end_use.visible = end_use.title.search(regex) > -1;
      });

      this.$scope.search_filter = {
        visible: true
      };
    } else {
      this.$scope.search_filter = {};
    }
  }

  update() {
    this.$scope.updating = true;
    var product_end_uses = _.where(this.$scope.product_end_uses, {
      checked: true
    });
    product_end_uses = _.pluck(product_end_uses, 'id');
    this.ProductService.update_product_end_uses(this.$scope.product.id,
      product_end_uses)
      .then(() => {
        this.$scope.updating = false;
      });
  }

  open_add_dialog() {
    var product_end_uses = _.where(this.$scope.product_end_uses, {
      checked: true
    });

    var data = {
      product_categories: this.$scope.product_categories,
      product_end_uses: angular.copy(product_end_uses),
      product: this.$scope.product
    };

    this.$rootScope.$broadcast('show_product_end_use_add_dialog', data);
  }
}

ProductEndUsesManage.$inject = ['$scope', '$rootScope', 'ProductService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/product-end-uses-manage.ctrl.js